import { render, staticRenderFns } from "./GameConfig.vue?vue&type=template&id=662e153a&scoped=true"
import script from "./GameConfig.vue?vue&type=script&lang=js"
export * from "./GameConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662e153a",
  null
  
)

export default component.exports